import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import Logo from '../../imgs/segurosuy.png'
import { Link } from 'react-router-dom'
import './logoEmpresa.css'

function LogoEmpresa(props) {
  // const children = props.children;

  return (
    <Container>
      <Row className="justify-content-sm-center">
        <Col>
          <img className="mx-auto d-block LogoEmpresa" src={Logo} alt="Logo Empresa" />
        </Col>
      </Row>
      <Row className="justify-content-sm-center rowLogoItems">
        <Col xs={2} md={1}>
          <Link to="/productos/rural/" >Rural</Link>
        </Col>
        <Col xs={2} md={1}>
          <Link to="/productos/vida/" >Vida</Link>
        </Col>
        <Col xs={2} md={1}>
          <Link to="/productos/hogar/" >Hogar</Link>
        </Col>
        <Col xs={2} md={1} className="logoEmpresaA">
          <Link to="/productos/automotor/" >Automotor</Link>
        </Col>
        <Col xs={2} md={1}>
          <Link to="/productos/comercio/" >Empresas</Link>
        </Col>
      </Row>
    </Container>
  )
}

export default LogoEmpresa